module.exports = __webpack_public_path__ + "img/lopez.768ade35.jpg";